import { useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { Toast } from 'primereact/toast'
import { TechnicalStandardsService } from '../../services/TechnicalStandardsService'
import { Dialog } from 'primereact/dialog'
import { removeUndefinedAndEmptyKeys } from '../helpers/RemoveUndefinedAndEmptyKeys'

export const TechnicalStandards = () => {
  const toast = useRef(null)

  const [allTechnicalStandards, setAllTechnicalStandards] = useState()
  const [technicalStandardsDescription, setTechnicalStandardsDescription] = useState({})
  const [category, setCategory] = useState({})
  const [typeParam, setTypeParam] = useState(undefined)
  const [categoryList, setCategoryList] = useState([])
  const [loading, setLoading] = useState(false)
  const [dialogError, setDialogError] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [dialogErrorVisible, setDialogErrorVisible] = useState(false)
  const [lazyState, setLazyState] = useState({
    first: 0,
    rows: 10,
    page: 0,
  })

  let isSearch

  const selectTechnicalStandardsDescription = [
    {
      key: 'Código do Material',
      value: 'codmtrntc',
    },
    {
      key: 'Descrição',
      value: 'descricao',
    },
    {
      key: 'Número da NTC',
      value: 'codntc',
    },
  ]

  const getTechnicalStandards = async (search) => {
    isSearch = search
    try {
      setLoading(true)
      const refinedObject = {
        categoria: category?.categoria?.id,
        ...technicalStandardsDescription,
        ...lazyState
      }

      const cleanedObject = removeUndefinedAndEmptyKeys(refinedObject)

      if (!typeParam && inputValue && isSearch) {
        isSearch = false
        setLoading(false)
        setDialogError('Selecione o campo de pesquisa')

        return setDialogErrorVisible(true)
      }

      const response =
        await TechnicalStandardsService.getAll(cleanedObject)

      if (isSearch) {
        setLazyState({
          first: 0,
          rows: 10,
          page: 0,
        })
      }

      setAllTechnicalStandards(response)
      setLoading(false)
      isSearch = false
    } catch (error) {
      setLoading(false)
      setDialogError(error?.response?.data?.userMessage)
      setDialogErrorVisible(true)
      isSearch = false

      toast.current?.show({
        severity: 'error',
        summary: 'Erro',
        detail: `Não foi possível carregar os dados da tabela: ${error}`,
        life: 3000,
      })
    }
  }

  useEffect(() => {
    getTechnicalStandards()
  }, [lazyState])

  useEffect(() => {
    const getCategoryList = async () => {
      try {
        const response = await TechnicalStandardsService.getAllCategories()

        setCategoryList(response)
      } catch (error) {
        setLoading(false)

        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: `Não foi possível carregar as categorias: ${error}`,
          life: 3000,
        })
      }
    }

    getTechnicalStandards()
    getCategoryList()
  }, [])

  const onPage = (event) => {
    if (event.page !== undefined) {
      setLazyState(event)
    }
  }

  const handleClick = async (itemId) => {
    const driveId = '724d9984-d00a-443e-92dd-84b15a23bcc7'

    try {
      setLoading(true)
      const response = await TechnicalStandardsService.getDocument(driveId, itemId)

      const blob = new Blob([response], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)

      window.open(url, '_blank')
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const renderLinkCell = (rowData, field) => {
    const document = rowData.documento.id
    const value = rowData[field]

    return (
      <div
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 1,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          cursor: 'pointer',
        }}
      >
        <a
          // target="_blank"
          onClick={() => handleClick(document)}
        >
          {value}
        </a>
      </div>
    )
  }

  useEffect(() => {
    setTechnicalStandardsDescription({
      [typeParam]: inputValue,
    })
  }, [typeParam, inputValue])

  return (
    <div
      className="flex flex-column w-11"
    >
      <Toast ref={toast} />

      <Dropdown
        value={category.categoria}
        options={categoryList.filter(categoria => !categoria.descricao?.includes('teste', 'Teste'))}
        optionLabel="descricao"
        placeholder="Normas de:"
        onChange={(event) => {
          setCategory({
            categoria: event.value,
          })
        }}
        showClear
        className="mb-2 w-full md:w-14rem"
      />

      <Dropdown
        value={typeParam}
        options={selectTechnicalStandardsDescription}
        optionLabel="key"
        placeholder="Selecione:"
        onChange={(event) => {
          setTypeParam(event.value)
        }}
        showClear
        className="mb-2 w-full md:w-14rem"
      />

      <div className="p-inputgroup mb-2 w-full md:w-14rem">
        <InputText
          onChange={(event) => {
            setInputValue(event.target.value)
          }}
        />
        <Button
          icon="pi pi-search"
          className="p-button-warning"
          onClick={async () => {
            await getTechnicalStandards(true)
          }}
        />
      </div>

      <DataTable
        dataKey="id"
        value={allTechnicalStandards?.content.filter(registro => !registro.descricao?.includes('Teste', 'teste', '_teste', 'TESTE'))}
        lazy
        loading={loading}
        paginator
        first={lazyState.first}
        totalRecords={allTechnicalStandards?.totalElements}
        rows={10}
        onPage={onPage}
        emptyMessage="Nenhum documento foi encontrado"
      >
        <Column field="documento.dataPublicacao" header="Data" />
        <Column
          field="codNtc"
          header="NTC"
          body={(rowData) => renderLinkCell(rowData, 'codNtc')}
        />
        <Column
          field="codMaterial"
          header="Material"
          body={(rowData) => renderLinkCell(rowData, 'codMtrNtc')}
        />
        <Column
          field="descricao"
          header="Descrição"
          body={(rowData) => renderLinkCell(rowData, 'descricao')}
        />
      </DataTable>

      <Dialog
        visible={dialogErrorVisible}
        onHide={() => {
          setDialogErrorVisible(false)
        }}
        header="Erro"
      >
        <div className="flex flex-column gap-2 align-items-center">
          <p>{dialogError}</p>

          <Button
            label="Ok" icon="pi pi-check"
            onClick={() => setDialogErrorVisible(false)}
            autoFocus
            style={{ width: '75px' }}
          />
        </div>
      </Dialog>
    </div>
  )
}
